import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import FixedActionBar from './components/FixedActionBar';
import Footer from './components/Footer';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import AboutPage from './pages/AboutPage';
import Authenticity from './pages/Authenticity';
import ContactPage from './pages/ContactPage';
import CookiePolicy from './pages/CookiePolicy';
import DeliveryPolicy from './pages/DeliveryPolicy';
import Disclaimer from './pages/Disclaimer';
import FaqPage from './pages/FaqPage';
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import TermsOfService from './pages/TermsOfService';
import { SITE_DOMAIN, SITE_NAME, SITE_TAGLINE } from './constants/site';

const PAGE_TITLES = {
  '/': `${SITE_NAME} | ${SITE_TAGLINE}`,
  '/about': `About Us | ${SITE_DOMAIN}`,
  '/contact': `Contact | ${SITE_DOMAIN}`,
  '/faqs': `FAQs | ${SITE_DOMAIN}`,
  '/privacy-policy': `Privacy Policy | ${SITE_DOMAIN}`,
  '/terms-of-service': `Terms of Service | ${SITE_DOMAIN}`,
  '/refund-policy': `Refund Policy | ${SITE_DOMAIN}`,
  '/return-policy': `Return Policy | ${SITE_DOMAIN}`,
  '/delivery-policy': `Delivery Policy | ${SITE_DOMAIN}`,
  '/cookie-policy': `Cookie Policy | ${SITE_DOMAIN}`,
  '/authenticity': `Authenticity | ${SITE_DOMAIN}`,
  '/disclaimer': `Disclaimer | ${SITE_DOMAIN}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || `${SITE_NAME} | ${SITE_DOMAIN}`;
  }, [pathname]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <DocumentTitle />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faqs" element={<FaqPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/delivery-policy" element={<DeliveryPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/authenticity" element={<Authenticity />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <FixedActionBar />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
